import {mergeProps as $dtb0o$mergeProps, filterDOMProps as $dtb0o$filterDOMProps} from "@react-aria/utils";
import {useFocusable as $dtb0o$useFocusable} from "@react-aria/focus";
import {usePress as $dtb0o$usePress} from "@react-aria/interactions";

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
var $9f08aaca62c37bf3$exports = {};

$parcel$export($9f08aaca62c37bf3$exports, "useToggle", () => $9f08aaca62c37bf3$export$cbe85ee05b554577);



function $9f08aaca62c37bf3$export$cbe85ee05b554577(props, state, ref) {
    let { isDisabled: isDisabled = false , isRequired: isRequired , isReadOnly: isReadOnly , value: value , name: name , children: children , 'aria-label': ariaLabel , 'aria-labelledby': ariaLabelledby , validationState: validationState = 'valid'  } = props;
    let onChange = (e)=>{
        // since we spread props on label, onChange will end up there as well as in here.
        // so we have to stop propagation at the lowest level that we care about
        e.stopPropagation();
        state.setSelected(e.target.checked);
    };
    let hasChildren = children != null;
    let hasAriaLabel = ariaLabel != null || ariaLabelledby != null;
    if (!hasChildren && !hasAriaLabel) console.warn('If you do not provide children, you must specify an aria-label for accessibility');
    // This handles focusing the input on pointer down, which Safari does not do by default.
    let { pressProps: pressProps  } = $dtb0o$usePress({
        isDisabled: isDisabled
    });
    let { focusableProps: focusableProps  } = $dtb0o$useFocusable(props, ref);
    let interactions = $dtb0o$mergeProps(pressProps, focusableProps);
    let domProps = $dtb0o$filterDOMProps(props, {
        labelable: true
    });
    return {
        inputProps: $dtb0o$mergeProps(domProps, {
            'aria-invalid': validationState === 'invalid' || undefined,
            'aria-errormessage': props['aria-errormessage'],
            'aria-controls': props['aria-controls'],
            'aria-readonly': isReadOnly || undefined,
            'aria-required': isRequired || undefined,
            onChange: onChange,
            disabled: isDisabled,
            value: value,
            name: name,
            type: 'checkbox',
            ...interactions
        })
    };
}




export {$9f08aaca62c37bf3$export$cbe85ee05b554577 as useToggle};
//# sourceMappingURL=module.js.map
